import {
  call,
  put,
  all,
  takeEvery,
  takeLatest,
  select,
} from "redux-saga/effects";
import { authActions, generalActions, spActions } from "../actions";
import api from "../services/sp.services";
import ACTIONS from "../constants";
import {TOAST_TYPE, USER_ROLE} from "../../Constants/constant";
import GetItemFromLocalstorage from "../../Utils/GetItemFromLocalstorage";
import { normalizeServiceProviderForClient } from "../../Utils/serviceProviderStatus.utils";
import { notifyWorkerComplianceSettingsUpdated } from "../../Utils/workerComplianceSync";
import {
  getRefreshManagerList,
  getSpParticipantComplianceSetting,
} from "store/selector/sp.selector";
import {roleAccess} from "../../helpers/RolesPermission";
import { mergePaymentSetting } from "../../helpers/planFeatures";
// import { authenticatedUser } from "store/actions/auth.actions";

function* getSPParticipants(state) {
  try {
    yield put(spActions.getSPParticipantsList.pending);
    const response = yield call(api.participantListRequest, state.payload);
    if (response.data) {
      yield put(spActions.getSPParticipantsList.success(response));
    }
  } catch (error) {
    console.log("error", error);
    yield put(spActions.getSPParticipantsList.error(error));
  }
}

function* getSPApplicants() {
  try {
    yield put(spActions.getSPApplicantsList.pending);
    const response = yield call(api.applicantsListRequest);
    if (response) {
      yield put(spActions.getSPApplicantsList.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPApplicantsList.error(error));
  }
}

function* getSPEmployeeDocuments() {
  try {
    yield put(spActions.getSPEmployeeDocuments.pending);
    const response = yield call(api.employeeDocumentsRequest);
    if (response) {
      yield put(spActions.getSPEmployeeDocuments.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPEmployeeDocuments.error(error));
  }
}

function* getSPDashboard() {
  try {
    yield put(spActions.getSPDashboard.pending);
    const response = yield call(api.dashboardRequest);
    if (response) {
      yield put(spActions.getSPDashboard.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPDashboard.error(error));
  }
}

function* getSpWorkers() {
  try {
    yield put(spActions.getSPWorker.pending);
    const response = yield call(api.spWorkerRequest);
    // const response = roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager,USER_ROLE.Sp_Standard_User]) && (yield call(api.spWorkerRequest));
    if (response) {
      yield put(spActions.getSPWorker.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPWorker.error(error));
  }
}

function* getSPFeedbacks(state) {
  try {
    yield put(spActions.getFeedback.pending);
    const response = yield call(api.feedbackRequest, state.payload);
    if (response) {
      yield put(spActions.getFeedback.success(response));
    }
  } catch (error) {
    yield put(spActions.getFeedback.error(error));
  }
}

function* getSPComplaints(state) {
  try {
    yield put(spActions.getComplaints.pending);
    const response = yield call(api.getComplaintsRequests, state.payload);
    if (response) {
      yield put(spActions.getComplaints.success(response));
    }
  } catch (error) {
    yield put(spActions.getComplaints.error(error));
  }
}

function* getSPQuestions(state) {
  try {
    yield put(spActions.getQuestions.pending);
    const response = yield call(api.getQuestionsRequests, state.payload);
    if (response) {
      yield put(spActions.getQuestions.success(response));
    }
  } catch (error) {
    yield put(spActions.getQuestions.error(error));
  }
}

function* getFormCategories(state) {
  try {
    yield put(spActions.SpFormCategories.pending);
    const res = yield call(api.formCategoriesRequest, {
      role: state.payload?.role,
    });
    if (res) {
      yield put(spActions.SpFormCategories.success(res));
    } else {
      yield put(
        spActions.SpFormCategories.success({
          form_categories: [],
        })
      );
    }
  } catch (error) {
    yield put(spActions.SpFormCategories.error(error));
  }
}

function* getAllForms(state) {
  try {
    yield put(spActions.spAllForm.pending);
    const response = yield call(api.allFormsRequest, state.payload);
    if (response) {
      yield put(spActions.spAllForm.success(response));
    }
  } catch (error) {
    yield put(spActions.spAllForm.error(error));
  }
}

function* getSPDocuments(state) {
  try {
    yield put(spActions.getSPDocuments.pending);
    const response = yield call(api.DocumentsRequest, state.payload);
    if (response.data) {
      yield put(spActions.getSPDocuments.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPDocuments.error(error));
  }
}

function* updateSpDocument(state) {
  try {
    yield put(spActions.updateSPDocuments.pending);
    const response = yield call(api.updateSpDocumentService, state.payload);
    if (response) {
      yield put(spActions.updateSPDocuments.success(state.payload));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Update document Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(spActions.updateSPDocuments.error(error));
  }
}

function* getHRMDocuments(state) {
  try {
    yield put(spActions.getHRMDocuments.pending);
    const response = yield call(api.DocumentsHrmRequest, state.payload);
    if (response.data) {
      yield put(spActions.getHRMDocuments.success(response));
    }
  } catch (error) {
    yield put(spActions.getHRMDocuments.error(error));
  }
}

function* getSPRiskRatingTab(state) {
  try {
    yield put(spActions.getSPRiskRatingList.pending);
    const response = yield call(api.RiskRatingTabListSPRequest, state.payload);
    if (response.data) {
      yield put(spActions.getSPRiskRatingList.success(response));
    }
  } catch (error) {
    yield put(spActions.getSPRiskRatingList.error(error));
  }
}

function* createSPManager(state) {
  try {
    yield put(spActions.createSPManager.pending);
    const response = yield call(
      state.isUpdateCall ? api.updateSpManager : api.createSPManager,
      state.payload
    );
    if (response) {
      yield put(
        spActions.createSPManager.success(
          {
            manager: state.isUpdateCall ? state.payload : response.manager,
          },
          state.isUpdateCall
        )
      );
      const refreshManagerList = yield select(getRefreshManagerList);
      yield put(spActions.refreshManagerList(!refreshManagerList));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: state.isUpdateCall
            ? "Primary Portal User Updated Successfully!"
            : "Primary Portal User Created Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.createSPManager.error(error.message));
  }
}

function* getSPManager() {
  try {
    yield put(spActions.SPManagerList.pending);
    const response = yield call(api.getSPManager);
    if (response) {
      yield put(spActions.SPManagerList.success(response));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.SPManagerList.error(error.message));
  }
}

function* getSPSupportPlanSubmittedFormsList(state) {
  try {
    const userType = yield localStorage.getItem("userType");
    yield put(spActions.getSupportPlanSubmittedFormsList.pending);

    const response = yield call(api.getSPSupportPlanSubmittedFormsListRequest, {
      ...state.payload,
      userType,
    });
    if (response.data) {
      yield put(spActions.getSupportPlanSubmittedFormsList.success(response));
    }
  } catch (error) {
    yield put(spActions.getSupportPlanSubmittedFormsList.error(error));
  }
}

function* getHRMTeamManagment(state) {
  try {
    yield put(spActions.getHRMTeamManagmentList.pending);
    const response = yield call(api.teamManagmentListRequest, state.payload);
    if (response.data) {
      yield put(spActions.getHRMTeamManagmentList.success(response));
    }
  } catch (error) {
    yield put(spActions.getHRMTeamManagmentList.error(error));
  }
}


function* getSPSetting(state) {
  try {
    yield put(spActions.getSpSettingFetched.pending);
    const response = yield call(api.spSettingRequest, state.payload);
    if (response.data) {
      yield put(spActions.getSpSettingFetched.success(response));
      const settingData = response.data?.data ?? response.data;
      const userType = yield localStorage.getItem("userType");
      if (settingData?.care_sector) {
        yield localStorage.setItem("spCareSector", settingData.care_sector);
      }
      const data = yield GetItemFromLocalstorage("user") || null;
      if (data && settingData) {
        if (data.profile_picture !== settingData.profile_picture) {
          yield (data.profile_picture = settingData.profile_picture);
        }
        if (data.logo !== settingData.logo) {
          yield (data.logo = settingData.logo);
        }
        // SP settings name is the org owner — only apply to SP admin accounts.
        if (userType === USER_ROLE.Sp_Admin) {
          yield (data.name = settingData.name);
        }
        if (data.hasOwnProperty("service_provider") && settingData) {
          yield (data.service_provider = normalizeServiceProviderForClient({
            ...data.service_provider,
            ...settingData,
          }));
        }
        yield localStorage.setItem("user", JSON.stringify(data));
        yield put(authActions.updateAuthUser(data));
      }
    }
  } catch (error) {
    yield put(spActions.getSpSettingFetched.error(error));
  }
}

function* spSettingUpdate(state) {
  try {
    yield put(spActions.spSettingupdated.pending);
    const response = yield call(api.spSettingUpdate, state.payload);
    if (response.data) {
      yield put(spActions.spSettingupdated.success(response.data));
      yield localStorage.setItem("spSettings", JSON.stringify(response.data));
      if (response.data?.care_sector) {
        yield localStorage.setItem("spCareSector", response.data.care_sector);
      }
      const data = yield GetItemFromLocalstorage("user") || null;
      if (data && response.data) {
        yield (data.profile_picture = response.data.profile_picture);
        yield (data.logo = response.data.logo);
        yield (data.name = response.data.name);
        if (data.hasOwnProperty("service_provider") && response.data) {
          yield (data.service_provider = normalizeServiceProviderForClient({
            ...data.service_provider,
            ...response.data,
          }));
        }
        yield localStorage.setItem("user", JSON.stringify(data));
        yield put(authActions.updateAuthUser(data));
      }

      // Keep sidebar Audit Log / journey tracking in sync after SP settings save
      const payload = state.payload;
      const hasJourneyTrackingUpdate =
        typeof FormData !== "undefined" && payload instanceof FormData
          ? payload.has("user_journey_tracking")
          : payload?.user_journey_tracking !== undefined;
      if (hasJourneyTrackingUpdate) {
        yield put(spActions.spRosteringSettingsRequest());
      }

      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "SP Admin Setting Updated Successfully!",
        })
      );
    }
  } catch (error) {
    yield put(spActions.spSettingupdated.error(error));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ?? "Something went Wrong!",
      })
    );
  }
}

function* workerProfileDetailsFetch(state) {
  try {
    yield put(spActions.workerProfileDetailsFetched.pending);

    const response = yield call(api.workerProfileSettingRequest, state.payload);
    if (response) {
      yield put(
        spActions.workerProfileDetailsFetched.success(response.profile)
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.workerProfileDetailsFetched.error(error));
  }
}

function* updateWorkerHourlySetting(state) {
  try {
    yield put(spActions.workerHourlyRateSettingUpdated.pending);

    const response = yield call(
      api.workerHourlyRateSettingUpdateRequest,
      state.payload
    );
    if (response.data) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Worker Setting Updated Successfully!",
        })
      );
      yield put(spActions.workerHourlyRateSettingUpdated.success(response));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.workerHourlyRateSettingUpdated.error(error));
  }
}

function* updateWorkerStatus(state) {
  try {
    yield put(spActions.workerStatusUpdated.pending);
    const response = yield call(api.workerStatusUpdateRequest, state.payload);
    if (response) {
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: `Worker ${
            state.payload.status ? "Activated" : "Deactivated"
          } Successfully!`,
        })
      );
      yield put(spActions.workerStatusUpdated.success({ ...state.payload }));
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.workerStatusUpdated.error(error));
  }
}

//Stripe
function* stripePricingTableList() {
  try {
    yield put(spActions.stripePricingTableList.pending);
    const response = yield call(api.stirpePricingTableList);
 
    if (response?.data) {
      yield put(spActions.stripePricingTableList.success(response.data));
    }
  } catch (error) {
    yield put(spActions.stripePricingTableList.error(error?.message ?? error));
  }
}

function* stripeSaveCardData(state) {
  try {
    yield put(spActions.stripeSaveCardData.pending);
    const response = yield call(api.stirpeSaveCardDataApi, state.payload);
    // console.log("response", response);
    if (response?.data) {
      yield put(
        spActions.stripeSaveCardData.success(response.data, state.data)
      );
      const user = yield GetItemFromLocalstorage("user");
      const subscribedWithPlan = Object.prototype.hasOwnProperty.call(
        state.payload,
        "price_id"
      );

      if (user && response?.data) {
        if (response.data.default_payment_method_id) {
          user.is_default_card = response.data.default_payment_method_id;
        }
        if (
          subscribedWithPlan ||
          response.data.subscription_id ||
          response.data.subscription_status ||
          response.data.current_subscription_status
        ) {
          user.payment_setting = mergePaymentSetting(
            user?.payment_setting,
            response.data
          );
        } else if (
          response.data.default_payment_method_id &&
          user?.payment_setting?.default_payment_method_id !==
            response.data.default_payment_method_id
        ) {
          user.payment_setting = mergePaymentSetting(
            user?.payment_setting,
            response.data
          );
        }
      }

      yield localStorage.setItem("user", JSON.stringify(user));
      yield put(authActions.authenticatedUser(user));
      if (response?.data) {
        yield put(authActions.updateStripePaymentSettingLocally(response.data));
      }

      if (state.payload.hasOwnProperty("price_id")) {
        yield put(
          generalActions.showToast({
            type: TOAST_TYPE.DEFAULT,
            title:
              "Thank you for subscribing! Your subscription is currently being processed and will be updated shortly.",
          })
        );
        if (typeof window !== "undefined") {
          window.dispatchEvent(
            new CustomEvent("vertex360:stripe-subscription-updated")
          );
        }
      }
    }
  } catch (error) {
    // console.log("err", error);
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
    yield put(spActions.stripeSaveCardData.error(error?.message ?? error));
  }
}

function* stripeListAllCard() {
  try {
    yield put(spActions.stripeListAllCard.pending);
    const response = yield call(api.stirpeListAllCardApi);
    if (response?.payment_methods) {
      yield put(
        spActions.stripeListAllCard.success(
          response?.payment_methods?.data || []
        )
      );
    }
  } catch (error) {
    yield put(spActions.stripeListAllCard.error(error?.message ?? error));
  }
}

function* stripeDefaultPaymentMethod() {
  try {
    yield put(spActions.stripeGetDefaultPaymentCard.pending);
    const response = yield call(api.stirpeGetDefaultPaymentMethod);
    if (response?.payment_setting) {
      const user = yield GetItemFromLocalstorage("user");

      yield (user.is_default_card =
        response.payment_setting.default_payment_method_id);
      yield (user.payment_setting = mergePaymentSetting(
        user?.payment_setting,
        response?.payment_setting
      ));
      yield localStorage.setItem("user", JSON.stringify(user));
      yield put(authActions.authenticatedUser(user));
      yield put(
        authActions.updateStripePaymentSettingLocally(response?.payment_setting)
      );
      yield put(
        spActions.stripeGetDefaultPaymentCard.success(
          response?.payment_methods?.data || []
        )
      );
    }
  } catch (error) {
    yield put(
      spActions.stripeGetDefaultPaymentCard.error(error?.message ?? error)
    );
  }
}

/** Refresh payment setting only (participant limit status, etc.) and update auth state. No card UI loading. */
function* refreshPaymentSettingSaga() {
  try {
    const response = yield call(api.stirpeGetDefaultPaymentMethod);
    if (response?.payment_setting) {
      const user = yield GetItemFromLocalstorage("user");
      if (user) {
        user.payment_setting = mergePaymentSetting(
          user.payment_setting,
          response.payment_setting
        );
        localStorage.setItem("user", JSON.stringify(user));
        yield put(authActions.authenticatedUser(user));
        yield put(
            authActions.updateStripePaymentSettingLocally(user.payment_setting)
        );
      }
    }
  } catch (_error) {
    // Silent fail: banner and limit status will use last known state
  }
}
function processParticipantComplianceResponse(participantComplianceSettings) {
  if (!participantComplianceSettings) return null;
  const { docs, forms } = participantComplianceSettings;
  let documentArray = [];
  if (Array.isArray(docs)) {
    documentArray = docs;
  } else {
    documentArray = Object.entries(docs || {}).flatMap(([, items]) => items || []);
  }
  documentArray.sort((a, b) => {
    const orderA = a.display_order ?? Number.MAX_SAFE_INTEGER;
    const orderB = b.display_order ?? Number.MAX_SAFE_INTEGER;
    if (orderA !== orderB) return orderA - orderB;
    return (a.id ?? 0) - (b.id ?? 0);
  });
  const processedDocuments = documentArray.map((item) => ({
    ...item,
    is_compliance: item.score <= 0 ? false : !!item.is_compliance,
  }));
  const processedForms =
    forms == null
      ? undefined
      : (forms || []).map((item) => ({
          ...item,
          is_compliance: item.score <= 0 ? false : !!item.is_compliance,
        }));
  return {
    document: processedDocuments,
    ...(processedForms !== undefined ? { form: processedForms } : {}),
    categories: [],
  };
}

function processWorkerComplianceResponse(workerComplianceSettings) {
  if (!workerComplianceSettings) return null;
  const { docs, forms, worker_compliance_email_notification, categories } = workerComplianceSettings;
  const documentArray = Object.entries(docs || {}).flatMap(([category, items]) =>
    (items || []).map((item) => ({
      ...item,
      is_compliance: item.score <= 0 ? false : !!item.is_compliance,
      category,
    }))
  );
  const processedDocuments = documentArray.map((item) => ({
    ...item,
    is_compliance: item.score <= 0 ? false : !!item.is_compliance,
    require_issue_date: !!item.require_issue_date,
    require_expiry_date: !!item.require_expiry_date,
  }));
  const processedForms = (forms || []).map((item) => ({
    ...item,
    is_compliance: item.score <= 0 ? false : !!item.is_compliance,
  }));
  return {
    document: processedDocuments,
    form: processedForms,
    worker_compliance_email_notification: worker_compliance_email_notification || false,
    categories: categories || [],
  };
}

function* spStaffComplianceSetting(action) {
  try {
    yield put(spActions.spStaffComplianceSettings.pending);
    const roleId = action.payload?.roleId ?? action.roleId ?? null;
    const response = yield call(api.getSpStaffComplianceSettingApi, roleId);

    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }

      // yield put(
      //   spActions.spStaffComplianceSettings.success(
      //     response?.worker_compliance_settings.reduce(
      //       (acc, item) => {
      //         if (item.type === "document") {
      //           acc.document.push({
      //             ...item,
      //             is_compliance: item.score <= 0 ? false : item.is_compliance,
      //           });
      //         } else {
      //           acc.form.push({
      //             ...item,
      //             is_compliance: item.score <= 0 ? false : item.is_compliance,
      //           });
      //         }
      //
      //         return acc;
      //       },
      //       { document: [], form: [] }
      //     ) || { document: [], form: [] }
      //   )
      // );
    }
  } catch (error) {
    yield put(
      spActions.spStaffComplianceSettings.error(error?.message ?? error)
    );
  }
}

function* spStaffComplianceSettingUpdate(state) {
  try {
    yield put(spActions.spStaffComplianceSettingsUpdate.pending);
    const response = yield call(
        api.updateSpStaffComplianceSettingApi,
        state.payload
    );

    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(
          spActions.spStaffComplianceSettingsUpdate.success(payload)
        );
      }

      // yield put(
      //     spActions.spStaffComplianceSettingsUpdate.success(
      //         response?.worker_compliance_settings.reduce(
      //             (acc, item) => {
      //               if (item.type === "document") {
      //                 acc.document.push(item);
      //               } else {
      //                 acc.form.push(item);
      //               }
      //
      //               return acc;
      //             },
      //             { document: [], form: [] }
      //         ) || { document: [], form: [] }
      //     )
      // );
      yield call(notifyWorkerComplianceSettingsUpdated);
      yield put(
          generalActions.showToast({
            type: TOAST_TYPE.SUCCESS,
            title: "Worker Compliance Settings Updated Successfully.",
          })
      );
    }
  } catch (error) {
    yield put(
        spActions.spStaffComplianceSettingsUpdate.error(error?.message ?? error)
    );
    yield put(
        generalActions.showToast({
          type: TOAST_TYPE.ERROR,
          title: error.message,
        })
    );
  }
}

let addDocumentInFlight = false;
function* spStaffComplianceAddDocument(state) {
  if (addDocumentInFlight) return;
  addDocumentInFlight = true;
  try {
    const response = yield call(
      api.addSpWorkerComplianceDocumentApi,
      state.payload
    );
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield put(spActions.spStaffComplianceAddDocumentCompleted({ success: true }));
      yield call(notifyWorkerComplianceSettingsUpdated);
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Document added successfully.",
        })
      );
    } else {
      yield put(spActions.spStaffComplianceAddDocumentCompleted({ success: false }));
    }
  } catch (error) {
    yield put(spActions.spStaffComplianceAddDocumentCompleted({ success: false }));
    const scoreErrors = error?.response?.data?.errors?.score;
    const toastMessage = Array.isArray(scoreErrors) && scoreErrors.length > 0
      ? [...new Set(scoreErrors)].join(" ")
      : error?.response?.data?.message || error?.message || "Failed to add document.";
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: toastMessage,
      })
    );
  } finally {
    addDocumentInFlight = false;
  }
}

let createCategoryInFlight = false;

function* spStaffComplianceCreateCategory(state) {
  if (createCategoryInFlight) return;
  createCategoryInFlight = true;
  try {
    const response = yield call(
      api.createSpWorkerComplianceCategoryApi,
      state.payload
    );
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield put(spActions.spStaffComplianceCreateCategoryCompleted({ success: true }));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category created successfully.",
        })
      );
    } else {
      yield put(spActions.spStaffComplianceCreateCategoryCompleted({ success: false }));
    }
  } catch (error) {
    yield put(spActions.spStaffComplianceCreateCategoryCompleted({ success: false }));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to create category.",
      })
    );
  } finally {
    createCategoryInFlight = false;
  }
}

let documentDeleteInFlight = false;
function* spStaffComplianceDeleteDocument(state) {
  if (documentDeleteInFlight) return;
  documentDeleteInFlight = true;
  try {
    const { uuid, roleId } = state.payload;
    const response = yield call(api.deleteSpWorkerComplianceDocumentApi, uuid, roleId);
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield call(notifyWorkerComplianceSettingsUpdated);
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Document removed from compliance.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to remove document.",
      })
    );
  } finally {
    documentDeleteInFlight = false;
  }
}

// Guard so only one visibility PATCH runs at a time (same pattern as Add Document / Create Category)
let categoryVisibilityInFlight = false;

function* spStaffComplianceCategoryVisibility(state) {
  if (categoryVisibilityInFlight) return;
  categoryVisibilityInFlight = true;
  try {
    const { categoryId, isVisible, roleId } = state.payload;
    const response = yield call(
      api.updateSpWorkerComplianceCategoryVisibilityApi,
      categoryId,
      isVisible,
      roleId
    );
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: isVisible ? "Category is now visible." : "Category is now hidden.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to update visibility.",
      })
    );
  } finally {
    categoryVisibilityInFlight = false;
  }
}

let categoryUpdateInFlight = false;
function* spStaffComplianceCategoryUpdate(state) {
  if (categoryUpdateInFlight) return;
  categoryUpdateInFlight = true;
  try {
    const { categoryId, name, roleId } = state.payload;
    const response = yield call(
      api.updateSpWorkerComplianceCategoryApi,
      categoryId,
      name,
      roleId
    );
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category updated successfully.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to update category.",
      })
    );
  } finally {
    categoryUpdateInFlight = false;
  }
}

let categoryDeleteInFlight = false;
function* spStaffComplianceCategoryDelete(state) {
  if (categoryDeleteInFlight) return;
  categoryDeleteInFlight = true;
  try {
    const { categoryId, roleId } = state.payload;
    const response = yield call(api.deleteSpWorkerComplianceCategoryApi, categoryId, roleId);
    if (response?.worker_compliance_settings) {
      const payload = processWorkerComplianceResponse(response.worker_compliance_settings);
      if (payload) {
        yield put(spActions.spStaffComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category removed.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to delete category.",
      })
    );
  } finally {
    categoryDeleteInFlight = false;
  }
}

function* spParticipantComplianceSetting(action) {
  try {
    yield put(spActions.spParticipantComplianceSettings.pending);
    const profileUuid = action.payload?.profileUuid;
    const response = yield call(api.getSpParticipantComplianceSettingApi, profileUuid);
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
    }
  } catch (error) {
    yield put(
      spActions.spParticipantComplianceSettings.error(error?.message ?? error)
    );
  }
}

function* spParticipantComplianceSettingUpdate(state) {
  try {
    yield put(spActions.spParticipantComplianceSettingsUpdate.pending);
    const { profileUuid, ...payload } = state.payload;
    const response = yield call(
      api.updateSpParticipantComplianceSettingApi,
      payload,
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      yield put(spActions.spParticipantComplianceSettingsUpdate.success());
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Participant Compliance Settings Updated Successfully.",
        })
      );
    }
  } catch (error) {
    yield put(
      spActions.spParticipantComplianceSettingsUpdate.error(error?.message ?? error)
    );
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
  }
}

let addParticipantDocumentInFlight = false;
function* spParticipantComplianceAddDocument(state) {
  if (addParticipantDocumentInFlight) return;
  addParticipantDocumentInFlight = true;
  try {
    const { profileUuid, ...payload } = state.payload;
    const response = yield call(
      api.addSpParticipantComplianceDocumentApi,
      payload,
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(spActions.spParticipantComplianceAddDocumentCompleted({ success: true }));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Document added successfully.",
        })
      );
    } else {
      yield put(spActions.spParticipantComplianceAddDocumentCompleted({ success: false }));
    }
  } catch (error) {
    yield put(spActions.spParticipantComplianceAddDocumentCompleted({ success: false }));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to add document.",
      })
    );
  } finally {
    addParticipantDocumentInFlight = false;
  }
}

let createParticipantCategoryInFlight = false;
function* spParticipantComplianceCreateCategory(state) {
  if (createParticipantCategoryInFlight) return;
  createParticipantCategoryInFlight = true;
  try {
    const { profileUuid, ...payload } = state.payload;
    const response = yield call(
      api.createSpParticipantComplianceCategoryApi,
      payload,
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(spActions.spParticipantComplianceCreateCategoryCompleted({ success: true }));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category created successfully.",
        })
      );
    } else {
      yield put(spActions.spParticipantComplianceCreateCategoryCompleted({ success: false }));
    }
  } catch (error) {
    yield put(spActions.spParticipantComplianceCreateCategoryCompleted({ success: false }));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to create category.",
      })
    );
  } finally {
    createParticipantCategoryInFlight = false;
  }
}

let participantDocumentDeleteInFlight = false;
function* spParticipantComplianceDeleteDocument(state) {
  if (participantDocumentDeleteInFlight) return;
  participantDocumentDeleteInFlight = true;
  try {
    const { uuid, profileUuid } = state.payload;
    const response = yield call(api.deleteSpParticipantComplianceDocumentApi, uuid, profileUuid);
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Document removed from compliance.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to remove document.",
      })
    );
  } finally {
    participantDocumentDeleteInFlight = false;
  }
}

let participantDocumentUpdateInFlight = false;
function* spParticipantComplianceUpdateDocument(state) {
  if (participantDocumentUpdateInFlight) return;
  participantDocumentUpdateInFlight = true;
  try {
    const { uuid, profileUuid, name, score, is_compliance, require_issue_date, require_expiry_date } =
      state.payload;
    const response = yield call(
      api.updateSpParticipantComplianceDocumentApi,
      uuid,
      {
        name,
        score,
        is_compliance,
        require_issue_date,
        require_expiry_date,
      },
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(spActions.spParticipantComplianceUpdateDocumentCompleted({ success: true }));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Document updated successfully.",
        })
      );
    }
  } catch (error) {
    yield put(spActions.spParticipantComplianceUpdateDocumentCompleted({ success: false }));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to update document.",
      })
    );
  } finally {
    participantDocumentUpdateInFlight = false;
  }
}

let participantCategoryVisibilityInFlight = false;
function* spParticipantComplianceCategoryVisibility(state) {
  if (participantCategoryVisibilityInFlight) return;
  participantCategoryVisibilityInFlight = true;
  try {
    const { categoryId, isVisible, profileUuid } = state.payload;
    const response = yield call(
      api.updateSpParticipantComplianceCategoryVisibilityApi,
      categoryId,
      isVisible,
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: isVisible ? "Category is now visible." : "Category is now hidden.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to update visibility.",
      })
    );
  } finally {
    participantCategoryVisibilityInFlight = false;
  }
}

let participantCategoryUpdateInFlight = false;
function* spParticipantComplianceCategoryUpdate(state) {
  if (participantCategoryUpdateInFlight) return;
  participantCategoryUpdateInFlight = true;
  try {
    const { categoryId, name, profileUuid } = state.payload;
    const response = yield call(
      api.updateSpParticipantComplianceCategoryApi,
      categoryId,
      name,
      profileUuid
    );
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        const prevSetting = yield select(getSpParticipantComplianceSetting);
        if (prevSetting?.categories?.length && payload?.categories?.length) {
          const newByUuid = new Map(payload.categories.map((c) => [c.uuid, c]));
          const newByOrder = new Map(payload.categories.map((c) => [c.display_order, c]));
          payload.categories = prevSetting.categories.map((prev) => {
            if (newByUuid.has(prev.uuid)) return newByUuid.get(prev.uuid);
            if (newByOrder.has(prev.display_order)) return newByOrder.get(prev.display_order);
            return prev;
          });
        }
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category updated successfully.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to update category.",
      })
    );
  } finally {
    participantCategoryUpdateInFlight = false;
  }
}

let participantCategoryDeleteInFlight = false;
function* spParticipantComplianceCategoryDelete(state) {
  if (participantCategoryDeleteInFlight) return;
  participantCategoryDeleteInFlight = true;
  try {
    const { categoryId, profileUuid } = state.payload;
    const response = yield call(api.deleteSpParticipantComplianceCategoryApi, categoryId, profileUuid);
    if (response?.participant_compliance_settings) {
      const payload = processParticipantComplianceResponse(response.participant_compliance_settings);
      if (payload) {
        yield put(spActions.spParticipantComplianceSettings.success(payload));
      }
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Category removed.",
        })
      );
    }
  } catch (error) {
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error?.response?.data?.message || error?.message || "Failed to delete category.",
      })
    );
  } finally {
    participantCategoryDeleteInFlight = false;
  }
}

function* spRosteringSetting() {
  try {
    yield put(spActions.spRosteringSettings.pending);
    const response = yield call(api.getSpRosteringSettingApi);
    if (response?.general_settings) {
      if (response.general_settings.care_sector) {
        yield localStorage.setItem(
          "spCareSector",
          response.general_settings.care_sector
        );
      }
      yield put(
        spActions.spRosteringSettings.success(response?.general_settings)
      );
    }
  } catch (error) {
    yield put(spActions.spRosteringSettings.error(error?.message ?? error));
  }
}

function* spRosteringSettingUpdate(state) {
  try {
    yield put(spActions.spRosteringSettingsUpdate.pending);
    const response = yield call(
      api.updateSpSRosteringSettingApi,
      state.payload
    );

    if (response?.general_settings) {
      yield put(
        spActions.spRosteringSettingsUpdate.success(response?.general_settings)
      );
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Rostering Settings Updated Successfully.",
        })
      );
    }
  } catch (error) {
    yield put(
      spActions.spRosteringSettingsUpdate.error(error?.message ?? error)
    );
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message,
      })
    );
  }
}
function* spShiftQuestionsAddSaga(state) {
  try {
    yield put(spActions.spShiftQuestionsAdd.pending);
    const response = yield call(api.addShiftQuestions, state.payload);

    if (response?.data) {
      yield put(spActions.spShiftQuestionsAdd.success(response.data));
      yield put(
        generalActions.showToast({
          type: TOAST_TYPE.SUCCESS,
          title: "Shift end questions added successfully.",
        })
      );
    }
  } catch (error) {
    yield put(spActions.spShiftQuestionsAdd.error(error?.message ?? error));
    yield put(
      generalActions.showToast({
        type: TOAST_TYPE.ERROR,
        title: error.message ?? "Failed to add shift end questions.",
      })
    );
  }
}




export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.SP_SETTING_FETCHED_CALL, getSPSetting),
    takeEvery(ACTIONS.SP_SETTING_UPDATED_CALL, spSettingUpdate),
    takeLatest(ACTIONS.SP_PARTICIPANTS_LIST_CALL, getSPParticipants),
    takeEvery(ACTIONS.SP_APPLICANTS_LIST_CALL, getSPApplicants),
    takeEvery(ACTIONS.SP_EMPLOYEE_DOCUMENTS_CALL, getSPEmployeeDocuments),
    takeEvery(ACTIONS.SP_DASHBOARD_CALL, getSPDashboard),
    takeLatest(ACTIONS.SP_WORKER_CALL, getSpWorkers),
    takeEvery(ACTIONS.SP_FEEDBACK_CALL, getSPFeedbacks),
    takeEvery(ACTIONS.SP_COMPLAINTS_CALL, getSPComplaints),
    takeEvery(ACTIONS.SP_QUESTIONS_CALL, getSPQuestions),
    takeLatest(ACTIONS.SP_FORM_CATEGORIES_CALL, getFormCategories),
    takeLatest(ACTIONS.SP_ALL_FORM_CALL, getAllForms),
    takeLatest(ACTIONS.SP_DOCUMENTS_CALL, getSPDocuments),
    takeLatest(ACTIONS.SP_DOCUMENTS_UPDATE_CALL, updateSpDocument),
    takeLatest(ACTIONS.HRM_DOCUMENTS_CALL, getHRMDocuments),
    takeLatest(ACTIONS.SP_RISK_RATING_TAB_LIST_CALL, getSPRiskRatingTab),
    takeLatest(ACTIONS.CREATE_SP_MANAGER_CALL, createSPManager),
    takeLatest(ACTIONS.SP_MANAGER_LIST_CALL, getSPManager),
    takeLatest(
      ACTIONS.SUPPORT_PLAN_SUBMITTED_FORMS_LIST_CALL,
      getSPSupportPlanSubmittedFormsList
    ),
    takeLatest(ACTIONS.HRM_TEAM_MANAGMENT_LIST_CALL, getHRMTeamManagment),

    takeLatest(
      ACTIONS.HRM_WORKER_PROFILE_DETAIL_CALL,
      workerProfileDetailsFetch
    ),
    takeLatest(
      ACTIONS.HRM_WORKER_HOURLY_SETTING_CALL,
      updateWorkerHourlySetting
    ),
    takeLatest(ACTIONS.HRM_WORKER_STATUS_UPDATE_CALL, updateWorkerStatus),
    takeEvery(ACTIONS.STRIPE_PRICING_TABLE_LIST_CALL, stripePricingTableList),
    takeLatest(ACTIONS.STRIPE_SAVE_CARD_DATA_CALL, stripeSaveCardData),
    takeEvery(ACTIONS.STRIPE_LIST_ALL_CARD_CALL, stripeListAllCard),
    takeEvery(
      ACTIONS.STRIPE_DEFAULT_PAYMENT_METHOD_CALL,
      stripeDefaultPaymentMethod
    ),
    takeEvery(
      ACTIONS.REFRESH_PAYMENT_SETTING_CALL,
      refreshPaymentSettingSaga
    ),
    takeLatest(
      ACTIONS.SP_STAFF_COMPLIANCE_SETTING_CALL,
      spStaffComplianceSetting
    ),
    takeLatest(
      ACTIONS.SP_STAFF_COMPLIANCE_SETTING_UPDATE_CALL,
      spStaffComplianceSettingUpdate
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_ADD_DOCUMENT_CALL,
      spStaffComplianceAddDocument
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_CREATE_CATEGORY_CALL,
      spStaffComplianceCreateCategory
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_CATEGORY_VISIBILITY_CALL,
      spStaffComplianceCategoryVisibility
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_CATEGORY_UPDATE_CALL,
      spStaffComplianceCategoryUpdate
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_CATEGORY_DELETE_CALL,
      spStaffComplianceCategoryDelete
    ),
    takeEvery(
      ACTIONS.SP_STAFF_COMPLIANCE_DELETE_DOCUMENT_CALL,
      spStaffComplianceDeleteDocument
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_SETTING_CALL,
      spParticipantComplianceSetting
    ),
    takeLatest(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_SETTING_UPDATE_CALL,
      spParticipantComplianceSettingUpdate
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_ADD_DOCUMENT_CALL,
      spParticipantComplianceAddDocument
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_CREATE_CATEGORY_CALL,
      spParticipantComplianceCreateCategory
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_CATEGORY_VISIBILITY_CALL,
      spParticipantComplianceCategoryVisibility
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_CATEGORY_UPDATE_CALL,
      spParticipantComplianceCategoryUpdate
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_CATEGORY_DELETE_CALL,
      spParticipantComplianceCategoryDelete
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_DELETE_DOCUMENT_CALL,
      spParticipantComplianceDeleteDocument
    ),
    takeEvery(
      ACTIONS.SP_PARTICIPANT_COMPLIANCE_UPDATE_DOCUMENT_CALL,
      spParticipantComplianceUpdateDocument
    ),

    takeLatest(ACTIONS.SP_ROSTERING_SETTING_CALL, spRosteringSetting),
    takeLatest(
      ACTIONS.SP_ROSTERING_SETTING_UPDATE_CALL,
      spRosteringSettingUpdate
    ),
    takeLatest(ACTIONS.SP_SHIFT_QUESTIONS_ADD_CALL, spShiftQuestionsAddSaga)
  ]);
}
